interface WatchLiveButtonProps {
  url: string;
  isCompleted?: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

export default function WatchLiveButton({ url, isCompleted = false, onClick }: WatchLiveButtonProps) {
  if (!url) return null;

  const label = isCompleted ? '🎬 Watch Replay' : '🎥 Watch Live';

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={onClick}
      className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-full bg-red-600 hover:bg-red-700 text-white text-xs font-bold shadow-sm hover:shadow-md transition-all self-start cursor-pointer"
    >
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="flex-shrink-0">
        {isCompleted ? (
          <>
            <polygon points="5 3 19 12 5 21 5 3" fill="currentColor" stroke="none" />
          </>
        ) : (
          <>
            <rect x="2" y="5" width="14" height="14" rx="2" />
            <path d="M23 7l-7 5 7 5V7z" fill="currentColor" stroke="none" />
          </>
        )}
      </svg>
      <span>{label}</span>
    </a>
  );
}
